import type { UserRole } from '@/shared/constants/roles'

// Single source of truth for "where does this role land after login or
// when they hit /". Each role has exactly one home page on the web app.
//
//   super_admin / admin  → /entities       (existing admin-tier landing)
//   hod                  → /hod/dashboard  (new HOD home)
//   field_officer        → /mobile-only    (web isn't for them)
//
// Imported by LoginPage's onSuccess + the root /  + /login redirect
// guards so the rules stay consistent across every entry point.
export type PostLoginPath =
  | '/entities'
  | '/hod/dashboard'
  | '/mobile-only'
  | '/login'

export function postLoginRedirect(role: UserRole | string | undefined): PostLoginPath {
  if (role === 'super_admin' || role === 'admin') {return '/entities'}
  if (role === 'hod') {return '/hod/dashboard'}
  if (role === 'field_officer') {return '/mobile-only'}
  return '/login'
}
